import * as Sentry from "@sentry/react";

/** For console logging in dev environment or capture exceptions with Sentry */
export const Logger = {
  console: (...text) =>
    process.env.REACT_APP_ENV === "dev" && console.log("%c🛠️ [log]:", "background: #303030; color: #fff", ...text),
  info: (...text) => process.env.REACT_APP_ENV === "dev" && console.log("%c🛠️ [info]:", "color: #2196f3", ...text),
  warn: (...text) => process.env.REACT_APP_ENV === "dev" && console.log("%c🛠️ [warn]:", "color: #ff9800", ...text),
  error: (...text) => process.env.REACT_APP_ENV === "dev" && console.log("%c🛠️ [error]:", "color: #f44336", ...text),
  sentry: {
    exception: (error, info) => {
      if (process.env.REACT_APP_ENV === "dev")
        console.log("%c🛠️ [exception]:", "background: #303030; color: #e57373", error, info);
      else {
        Sentry.setContext(info);
        Sentry.captureException(error, (context) => {
          if (info) context.setContext("info", info);
          return context;
        });
      }
    },
    message: (message) => {
      Sentry.captureMessage(message);
    },
  },
};
